var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRu = function SvgRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ru_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ru_svg__b)",
    fillRule: "evenodd",
    d: "M-4.8 0h33.6v24H-4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ru_svg__c)",
    fillRule: "evenodd",
    d: "M-4.8 8h33.6v8H-4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ru_svg__d)",
    fillRule: "evenodd",
    d: "M-4.8 16h33.6v8H-4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ru_svg__e)",
    fillRule: "evenodd",
    d: "M-4.8 0h33.6v8H-4.8z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru_svg__b",
    x1: 347.999,
    x2: 347.999,
    y1: 0,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru_svg__c",
    x1: 347.999,
    x2: 347.999,
    y1: 8,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C47B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073DA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru_svg__d",
    x1: 347.999,
    x2: 347.999,
    y1: 16,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D32E28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru_svg__e",
    x1: 347.999,
    x2: 347.999,
    y1: 0,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ru_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgRu;